import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const ORANGE = '#FF6900';

const CircularLoader = ({
    color = ORANGE,
    minHeight = '300px',
    size,
    sx = {},
}) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight,
            ...sx,
        }}>
            <CircularProgress sx={{ color }} size={size} />
        </Box>
    );
};

export default CircularLoader;
